import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'transfer', 'IconTransfer', [["path",{"d":"M20 10h-16l5.5 -6","key":"svg-0"}],["path",{"d":"M4 14h16l-5.5 6","key":"svg-1"}]]);